import ErrorBoundary from '@shared/components/ErrorBoundaries/ErrorBoundary';
import LayoutContainer from '@shared/components/Layout/LayoutContainer';
import importRemote from '@shared/utilities/federation/loadremote';
import React, { Suspense } from 'react';
import { Helmet } from 'react-helmet-async';

import PageLoader from '../../components/PageLoading';

const ContentRemote = React.lazy(() =>
    importRemote({
        remoteName: 'Content',
        scope: 'remote_content',
        module: 'EarlyBidding',
        remoteUrlLocation: process.env.REMOTE_CONTENT,
    })
);

const EarlyBiddingPage = () => {
    return (
        <>
            <Helmet>
                <title>Early Bidding | CarMax Auctions</title>
            </Helmet>
            <LayoutContainer hideSubHeader={true} includeFooter={true}>
                <ErrorBoundary>
                    <Suspense fallback={<PageLoader label="early-bidding" />}>
                        <ContentRemote />
                    </Suspense>
                </ErrorBoundary>
            </LayoutContainer>
        </>
    );
};

export default EarlyBiddingPage;
